<main id="my-name-maintenance" class="popup maintenance-form">
    <h2>Edit My Name</h2>
    <div>
        My name: <input type="text" id="my-name-input" class="input" value={$user.my_name}>
        Email address: <input type="text" id="email-input" class="input" value={$user.email}>
        <div>&nbsp</div>
        <div>Email address is not mandatory, but encouraged (see help).</div>
        <div>&nbsp</div>
    </div>
    <div class="buttons">
        <button class="select-button" on:click={saveData}>Save</button>
        <button class="select-button" on:click={close}>Close</button>
    </div>
</main>

<style>
    #my-name-maintenance {
        display: none;
    }
</style>


<script>
    import { elementDisplay } from './utilities'
    import { user } from './data-store.js'
    import { writeToUser } from './user.js';

    function saveData() {
        let my_name_input = document.getElementById('my-name-input');
        let email_input = document.getElementById('email-input');
        $user.my_name = my_name_input.value;
        $user.email = email_input.value;
        writeToUser();
        close();
    }

    function close() {
        elementDisplay('my-name-maintenance', 'none')
    }
</script>